import React, { useContext, useState } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import {
  Tab,
  TabList,
  makeStyles,
  tokens,
  shorthands,
} from '@fluentui/react-components';
import MatchedLocations from './matched-locations';
import UnmatchedLocations from './unmatched-locations';
import NoResultsMessage from './no-results-message';
import { useBulkLocationsSearchContext } from './bulk-locations-search-provider';
import { matchedTypes } from './utils/constants';

const useStyles = makeStyles({
  tabs: {
    ...shorthands.borderBottom(tokens.strokeWidthThin, 'solid', tokens.colorNeutralStroke1),
  },
});

const SearchResultsTabs = () => {
  const classes = useStyles();
  const i18n = useContext(I18nContext);
  const {
    unmatchedLocations, matchedLocations,
  } = useBulkLocationsSearchContext();
  const [selectedValue, setSelectedValue] = useState(matchedTypes.MATCHED);
  const subtext = i18n.getString(_TL_('Select Enter locations above if you’d like to add more.'));

  const onTabSelect = (_event, data) => {
    setSelectedValue(data.value);
  };

  return (
    <div>
      <TabList className={classes.tabs} selectedValue={selectedValue} onTabSelect={onTabSelect}>
        <Tab id={matchedTypes.MATCHED} value={matchedTypes.MATCHED}>
          {i18n.getString(_TL_('Found ({{count}})'), { count: matchedLocations.length })}
        </Tab>
        <Tab id={matchedTypes.UNMATCHED} value={matchedTypes.UNMATCHED}>
          {i18n.getString(_TL_('Not found ({{count}})'), { count: unmatchedLocations.length })}
        </Tab>
      </TabList>
      {selectedValue === matchedTypes.MATCHED &&
        <div role="tabpanel" aria-labelledby={matchedTypes.MATCHED}>
          {matchedLocations.length === 0 ? <NoResultsMessage title={i18n.getString(_TL_('There are no found locations.'))} subtext={subtext} /> : <MatchedLocations />}
        </div>}
      {selectedValue === matchedTypes.UNMATCHED &&
        <div role="tabpanel" aria-labelledby={matchedTypes.UNMATCHED}>
          {unmatchedLocations.length === 0 ? <NoResultsMessage title={i18n.getString(_TL_('All of your locations have been successfully found.'))} subtext={subtext} /> : <UnmatchedLocations />}
        </div>}
    </div>
  );
};

export default SearchResultsTabs;
